// extracted by mini-css-extract-plugin
export default {"togglePoiButton":"Map_togglePoiButton__PQ3nO","locationMarker":"Map_locationMarker__42yVL"};